import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// Connections, Connections, connections, connections
// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Connections = ({ blocks, context, setRestBlockError }) => {
    if (!setRestBlockError) return null;
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} setRestBlockError={setRestBlockError} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Connections' id='connections' iconclass='category with-icon-paths snap-icon-connection_dual'>{/* NOSONAR */}
                <label text="Connections"/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }
    
    return null;
};

Connections.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
    setRestBlockError: PropTypes.func,
};

export default Connections
